import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Exemptions',
    templateUrl: './Exemptions.component.html',
    styleUrls: ['./Exemptions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionsComponent implements OnInit {
  status=false;
  constructor() { }

  ngOnInit() {
  }

}
